import React from "react";
import { altColor } from "../../utils/constants";

export default function IconUnknown({ color = altColor }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 289.36 314.41">
      <g id="Ebene_2" data-name="Ebene 2">
        <g id="Ebene_1-2" data-name="Ebene 1">
          <path
            d="M192.58,96A8.28,8.28,0,0,0,181,84.12l-.15.15-123,123a34.85,34.85,0,0,0,49.28,49.28L274,89.71a52.55,52.55,0,0,0-74.32-74.32h0L20.32,194.73a70.26,70.26,0,0,0,99.35,99.37L255.19,158.58a8.28,8.28,0,1,0-11.56-11.86l-.15.15L108,282.39A53.7,53.7,0,0,1,32,206.44L211.36,27.1A36,36,0,0,1,262.25,78h0L95.44,244.82a18.29,18.29,0,0,1-26-25.72l.14-.14Z"
            fill={color}
          />
        </g>
      </g>
    </svg>
  );
}
